import { WarningCircle } from "@phosphor-icons/react";

export function InlineError({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="inline-error" role="alert">
      <WarningCircle size={22} aria-hidden="true" />
      <div>
        <strong>We could not load this information.</strong>
        <p>{message}</p>
      </div>
      {onRetry && <button className="text-button" type="button" onClick={onRetry}>Retry</button>}
    </div>
  );
}
